<div class="add-widgets-modal-content">
    <div class="add-widgets-modal-heading">
        <span class="close-icon" (click)="onCancel()">×</span>
        <img src="./assets/img/lpc-icon-add.svg" alt="+" />
        <h3 class="heading-text">{{ "control_add_widget" | translate }}</h3>
    </div>

    <div class="add-widgets-modal-body">
        @let widgets = widgets$ | async;
        @let commonWidgets = widgets | webWidgetGroup: "common";
        @let courseWidgets = widgets | webWidgetGroup: "course";

        @if (commonWidgets.length) {
            <h4 class="widgets-group-title">{{ "widgets_group_common" | translate }}</h4>
            <div class="widgets-list">
                @for (widget of commonWidgets; track widget) {
                    <web-toolbar-widget
                        [widget]="widget"
                        [eduTariff]="eduUserTariff$ | async"
                        [isAdmin]="isAdmin$ | async"
                        [isEduSite]="isEduSite$ | async"
                        (onClick)="onAddWidget(widget)"
                    ></web-toolbar-widget>
                }
            </div>
        }

        @if (courseWidgets.length) {
            <h4 class="widgets-group-title">{{ "widgets_group_courses" | translate }}</h4>
            <div class="widgets-list">
                @for (widget of courseWidgets; track widget) {
                    <web-toolbar-widget
                        [widget]="widget"
                        [eduTariff]="eduUserTariff$ | async"
                        [isAdmin]="isAdmin$ | async"
                        [isEduSite]="isEduSite$ | async"
                        (onClick)="onAddWidget(widget)"
                    ></web-toolbar-widget>
                }
            </div>
        }
    </div>
</div>
